import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { useColors } from "./ThemeContext";

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const C = useColors();
  const [toast, setToast] = useState(null);
  const timerRef = useRef(null);

  const showToast = useCallback((message, type = "error") => {
    if (!message) return;
    if (timerRef.current) clearTimeout(timerRef.current);
    setToast({ message, type });
    timerRef.current = setTimeout(() => setToast(null), 5200);
  }, []);

  const dismissToast = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setToast(null);
  }, []);

  useEffect(() => () => { if (timerRef.current) clearTimeout(timerRef.current); }, []);

  const toastStyle = {
    error: { border: C.danger + "55", text: C.danger },
    success: { border: C.lime + "55", text: C.lime },
    info: { border: C.info + "55", text: C.info },
  };
  const colors = toast ? (toastStyle[toast.type] || toastStyle.error) : null;

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      {toast && colors && (
        <div role="alert" style={{
          position: "fixed", top: 12, left: "50%", transform: "translateX(-50%)",
          width: "calc(100% - 24px)", maxWidth: 406, zIndex: 5000,
          padding: "12px 14px", borderRadius: 14,
          background: C.surface, border: `1px solid ${colors.border}`,
          display: "flex", alignItems: "flex-start", gap: 10,
          boxShadow: "0 8px 32px rgba(0,0,0,0.45)",
        }}>
          <p style={{ color: colors.text, fontSize: 13, fontWeight: 700, margin: 0, flex: 1, lineHeight: 1.45 }}>{toast.message}</p>
          <button type="button" onClick={dismissToast} aria-label="Dismiss" style={{
            background: "none", border: "none", color: C.muted, fontSize: 18, cursor: "pointer", lineHeight: 1, padding: 0,
          }}>×</button>
        </div>
      )}
    </ToastContext.Provider>
  );
}

export function useToast() {
  const showToast = useContext(ToastContext);
  return showToast || (() => { });
}
